$(document).ready(function () {
  var $emailInput = $('section.clNewsletter #email');
  var $emailWrapper = $emailInput.closest('section.clNewsletter .email');
  var $newsletterContent = $('section.clNewsletter .newsletterContent');
  $emailInput.on('focus', function () {
    $emailWrapper.addClass('active');
    $newsletterContent.stop(true, true).slideDown();
  });
  $emailInput.on('blur', function () {
    if ($emailInput.val().trim() === '') {
      $emailWrapper.removeClass('active');
    }
  });
  $('section.clNewsletter .newsletterContent .gender label input[type="checkbox"]').change(function () {
    var $inputBox = $(this).closest('.inputBox');
    
    if ($(this).is(':checked')) {
      $inputBox.addClass('active');
    } else {
      $inputBox.removeClass('active');
    }
  });
});

// $(document).ready(function () {
//   var $form = $('.clNewsletter form[action*="/contact"]');
//   var $email = $form.find('section.clNewsletter #email');
//   var $errorEmail = $form.find('section.clNewsletter .errorEmail');
//   var $checkboxes = $form.find('section.clNewsletter input[type="checkbox"]');
//   var $errorCheckbox = $form.find('section.clNewsletter .errorCheckbox');

//   $errorEmail.hide();
//   $errorCheckbox.hide();

//   $form.on('submit', function (e) {
//     var isValid = true;

//     // Email validation
//     var emailVal = $email.val().trim();
//     if (emailVal === '') {
//       $errorEmail.show();
//       $email.focus();
//       isValid = false;
//     } else {
//       $errorEmail.hide();
//     }

//     // Checkbox validation
//     var isAnyChecked = $checkboxes.is(':checked');
//     if (!isAnyChecked) {
//       $errorCheckbox.show();
//       if (isValid) $checkboxes.first().focus();
//       isValid = false;
//     } else {
//       $errorCheckbox.hide();
//     }

//     if (!isValid) {
//       e.preventDefault();
//       e.stopImmediatePropagation();
//     } else {
//       // Delay to let the form submit, then clear email
//       setTimeout(function () {
//         $email.val('');
//       }, 100);
//     }
//   });
// });
$(document).ready(function () {
  var $form = $('section.clNewsletter form[action*="/contact"]');
  var $email = $form.find('#email');
  var $errorEmail = $form.find('.errorEmail');
  var $checkboxes = $form.find('input[type="checkbox"]');
  var $errorCheckbox = $form.find('.errorCheckbox');

  $errorEmail.hide();
  $errorCheckbox.hide();

  // $form.on('submit', function (e) {
  //   var isValid = true;
  //   var emailVal = $email.val().trim();
  //   var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  //   if (emailVal === '' || !emailPattern.test(emailVal)) {
  //     $errorEmail.fadeIn(200);
  //     $email.focus();
  //     isValid = false;
  //   } else {
  //     $errorEmail.fadeOut(200);
  //   }

  //   var isAnyChecked = $checkboxes.is(':checked');
  //   if (!isAnyChecked) {
  //     $errorCheckbox.fadeIn(200);
  //     if (isValid) $checkboxes.first().focus();
  //     isValid = false;
  //   } else {
  //     $errorCheckbox.fadeOut(200);
  //   }

  //   if (!isValid) {
  //     e.preventDefault();
  //     e.stopImmediatePropagation();
  //     return false;
  //   }

  //   setTimeout(function () {
  //     $email.val('');
  //     $checkboxes.prop('checked', false);
  //   }, 100);
  // });
  $form.on('submit', function (e) {
    var isValid = true;
    var emailVal = $email.val().trim();
    var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
    if (emailVal === '' || !emailPattern.test(emailVal)) {
      $errorEmail.fadeIn(200);
      $email.focus();
      isValid = false;
    } else {
      $errorEmail.fadeOut(200);
    }
  
    var isAnyChecked = $checkboxes.is(':checked');
    if (!isAnyChecked) {
      $errorCheckbox.fadeIn(200);
      if (isValid) $checkboxes.first().focus();
      isValid = false;
    } else {
      $errorCheckbox.fadeOut(200);
    }
  
    if (!isValid) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
  
    e.preventDefault(); // remove agar real submit nahi karna
    $('.thankYouContent').fadeIn(300); // ye line add karo
    $email.val('');
    $checkboxes.prop('checked', false);
  });
  
});
